'use strict';
var BASWebServices;
(function (BASWebServices) {
    var FilenameAnnotDeleteFilter = (function () {
        function FilenameAnnotDeleteFilter() {
        }
        FilenameAnnotDeleteFilter.Factory = function () {
            return function (input) {
                if (angular.isArray(input)) {
                    var filtered = [];
                    angular.forEach(input, function (url) {
                        filtered.push(FilenameAnnotDeleteFilter.filter(url));
                    });
                    return filtered;
                }
                else if (angular.isString(input)) {
                    return FilenameAnnotDeleteFilter.filter(input);
                }
                else if (input === 'undefined') {
                    return 0;
                }
                else {
                    return input;
                }
            };
        };
        FilenameAnnotDeleteFilter.filter = function (filename) {
            return filename.replace("_annot.json", ".json");
        };
        return FilenameAnnotDeleteFilter;
    }());
    BASWebServices.FilenameAnnotDeleteFilter = FilenameAnnotDeleteFilter;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=FilenameAnnotDeleteFilter.js.map